import React from "react";
import RecordingMicPopover from "./RecordingMicPopover";

/**
 * Fixed recording popover for the sidebar dictation mic.
 */
const SidebarMicPopover = ({
  isRecording,
  macroCommandMode = false,
  streamingTranscript = "",
  dictationLanguage = "en-US",
  onStop,
  isRadicalAuth = false,
}) => (
  <RecordingMicPopover
    isActive={isRecording}
    streamingTranscript={streamingTranscript}
    dictationLanguage={dictationLanguage}
    isCommandMode={macroCommandMode}
    onStop={onStop}
    isRadicalAuth={isRadicalAuth}
    variant="sidebar"
  />
);

export default SidebarMicPopover;
